import React, { useState, useEffect } from 'react';
import axios from '../utils/axios';
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../img/tramites.png';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navegar = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navegar('/panel-admin');
        }
    }, [navegar]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email || !password) {
            toast.error('Todos los campos son obligatorios', {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post('auth', { email, password });
            localStorage.setItem('token', res.data.token);
            toast.success('¡Bienvenido!', {
                position: "top-right",
                autoClose: 2000,
                theme: "colored",
            });
            setTimeout(() => {
                navegar('/panel-admin');
            }, 500);
        } catch (error) {
            toast.error(error.response?.data?.error || 'Credenciales inválidas', {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            setLoading(false);
        }
    }

    return (
        <div className="login-container">
            <ToastContainer />
            <div className="login-background">
                <div className="login-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                </div>
            </div>
            
            <div className="login-content">
                <Link to="/" className="login-logo-link">
                    <img src={logo} alt="Tramites Pronto" className="login-logo" />
                </Link>
                
                <div className="login-card">
                    <div className="login-header">
                        <h2>Iniciar Sesión</h2>
                        <p>Ingresa tus credenciales para acceder al panel</p>
                            </div>
                            
                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <div className="input-wrapper">
                                <i className="fa-solid fa-envelope input-icon"></i>
                                        <input
                                    id="email"
                                            type="email"
                                    className="form-input"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                    placeholder="tu@email.com"
                                    disabled={loading}
                                        />
                                        {email && (
                                            <button 
                                                type="button"
                                        className="input-clear"
                                                onClick={() => setEmail('')}
                                        disabled={loading}
                                            >
                                                <i className="fa-solid fa-times"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>

                        <div className="form-group">
                            <label htmlFor="password">Contraseña</label>
                            <div className="input-wrapper">
                                <i className="fa-solid fa-lock input-icon"></i>
                                        <input
                                    id="password"
                                            type={showPassword ? "text" : "password"}
                                    className="form-input"
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                            placeholder="••••••••"
                                    disabled={loading}
                                        />
                                <div className="input-actions">
                                            <button 
                                                type="button"
                                        className="input-action-btn"
                                                onClick={() => setShowPassword(!showPassword)}
                                        disabled={loading}
                                            >
                                                <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                            </button>
                                            {password && (
                                                <button 
                                                    type="button"
                                            className="input-action-btn"
                                                    onClick={() => setPassword('')}
                                            disabled={loading}
                                                >
                                                    <i className="fa-solid fa-times"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <button 
                                    type="submit"
                            className="btn-login"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner"></span>
                                    Iniciando sesión...
                                </>
                            ) : (
                                <>
                                    <i className="fa-solid fa-sign-in-alt"></i>
                                    Ingresar
                                </>
                            )}
                                </button>
                            </form>

                    <div className="login-footer">
                        <Link to="/" className="back-link">
                            <i className="fa-solid fa-arrow-left"></i>
                            Volver al inicio
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
